import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const AssistantExtrasContext = createContext({
  extras: null,
  setPageExtras: () => {},
  clearPageExtras: () => {},
});

/** Live page state (e.g. Decision knobs) merged into assistant prompts. */
export function AssistantProvider({ children }) {
  const [extras, setExtras] = useState(null);

  const setPageExtras = useCallback((next) => {
    setExtras(next && typeof next === 'object' ? next : null);
  }, []);

  const clearPageExtras = useCallback(() => setExtras(null), []);

  const value = useMemo(
    () => ({ extras, setPageExtras, clearPageExtras }),
    [extras, setPageExtras, clearPageExtras],
  );

  return (
    <AssistantExtrasContext.Provider value={value}>{children}</AssistantExtrasContext.Provider>
  );
}

export function useAssistantPageExtras() {
  return useContext(AssistantExtrasContext);
}
